// Generated from ./util_cohort_builder_grammar/stable/NumericAttributesLexer.g4 by ANTLR 4.13.1

import * as antlr from "antlr4ng";
import { Token } from "antlr4ng";


export class NumericAttributesLexer extends antlr.Lexer {
    public static readonly DRUG_EXPOSURE_INT_ATTRIBUTE = 1;
    public static readonly MEASUREMENT_FLOAT_ATTRIBUTE = 2;
    public static readonly PERSON_INT_ATTRIBUTE = 3;
    public static readonly COMMON_NUMERIC_FLOAT_ATTRIBUTE = 4;
    public static readonly QUANTITY = 5;

    public static readonly channelNames = [
        "DEFAULT_TOKEN_CHANNEL", "HIDDEN"
    ];

    public static readonly literalNames = [
        null, null, null, null, "'value_as_number'", "'quantity'"
    ];

    public static readonly symbolicNames = [
        null, "DRUG_EXPOSURE_INT_ATTRIBUTE", "MEASUREMENT_FLOAT_ATTRIBUTE", 
        "PERSON_INT_ATTRIBUTE", "COMMON_NUMERIC_FLOAT_ATTRIBUTE", "QUANTITY"
    ];

    public static readonly modeNames = [
        "DEFAULT_MODE",
    ];

    public static readonly ruleNames = [
        "DRUG_EXPOSURE_INT_ATTRIBUTE", "MEASUREMENT_FLOAT_ATTRIBUTE", "PERSON_INT_ATTRIBUTE", 
        "COMMON_NUMERIC_FLOAT_ATTRIBUTE", "QUANTITY",
    ];


    public constructor(input: antlr.CharStream) {
        super(input);
        this.interpreter = new antlr.LexerATNSimulator(this, NumericAttributesLexer._ATN, NumericAttributesLexer.decisionsToDFA, new antlr.PredictionContextCache());
    }

    public get grammarFileName(): string { return "NumericAttributesLexer.g4"; }

    public get literalNames(): (string | null)[] { return NumericAttributesLexer.literalNames; }
    public get symbolicNames(): (string | null)[] { return NumericAttributesLexer.symbolicNames; }
    public get ruleNames(): string[] { return NumericAttributesLexer.ruleNames; }

    public get serializedATN(): number[] { return NumericAttributesLexer._serializedATN; }

    public get channelNames(): string[] { return NumericAttributesLexer.channelNames; }

    public get modeNames(): string[] { return NumericAttributesLexer.modeNames; }

    public static readonly _serializedATN: number[] = [
        4,0,5,130,6,-1,2,0,7,0,2,1,7,1,2,2,7,2,2,3,7,3,2,4,7,4,1,0,1,0,1,
        0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,3,
        0,30,8,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,
        1,1,1,1,1,1,1,1,1,1,3,1,51,8,1,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,
        2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,
        2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,
        2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,3,2,104,8,2,1,3,1,3,1,
        3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,4,1,4,1,
        4,1,4,1,4,1,4,1,4,1,4,1,4,0,0,5,1,1,3,2,5,3,7,4,9,5,1,0,0,134,0,
        1,1,0,0,0,0,3,1,0,0,0,0,5,1,0,0,0,0,7,1,0,0,0,0,9,1,0,0,0,1,29,1,
        0,0,0,3,50,1,0,0,0,5,103,1,0,0,0,7,105,1,0,0,0,9,121,1,0,0,0,11,
        12,5,114,0,0,12,13,5,101,0,0,13,14,5,102,0,0,14,15,5,105,0,0,15,
        16,5,108,0,0,16,17,5,108,0,0,17,30,5,115,0,0,18,19,5,100,0,0,19,
        20,5,97,0,0,20,21,5,121,0,0,21,22,5,115,0,0,22,23,5,95,0,0,23,24,
        5,115,0,0,24,25,5,117,0,0,25,26,5,112,0,0,26,27,5,112,0,0,27,28,
        5,108,0,0,28,30,5,121,0,0,29,11,1,0,0,0,29,18,1,0,0,0,30,2,1,0,0,
        0,31,32,5,114,0,0,32,33,5,97,0,0,33,34,5,110,0,0,34,35,5,103,0,0,
        35,36,5,101,0,0,36,37,5,95,0,0,37,38,5,104,0,0,38,39,5,105,0,0,39,
        40,5,103,0,0,40,51,5,104,0,0,41,42,5,114,0,0,42,43,5,97,0,0,43,44,
        5,110,0,0,44,45,5,103,0,0,45,46,5,101,0,0,46,47,5,95,0,0,47,48,5,
        108,0,0,48,49,5,111,0,0,49,51,5,119,0,0,50,31,1,0,0,0,50,41,1,0,
        0,0,51,4,1,0,0,0,52,53,5,121,0,0,53,54,5,101,0,0,54,55,5,97,0,0,
        55,56,5,114,0,0,56,57,5,95,0,0,57,58,5,111,0,0,58,59,5,102,0,0,59,
        60,5,95,0,0,60,61,5,98,0,0,61,62,5,105,0,0,62,63,5,114,0,0,63,64,
        5,116,0,0,64,104,5,104,0,0,65,66,5,109,0,0,66,67,5,111,0,0,67,68,
        5,110,0,0,68,69,5,116,0,0,69,70,5,104,0,0,70,71,5,95,0,0,71,72,5,
        111,0,0,72,73,5,102,0,0,73,74,5,95,0,0,74,75,5,98,0,0,75,76,5,105,
        0,0,76,77,5,114,0,0,77,78,5,116,0,0,78,104,5,104,0,0,79,80,5,100,
        0,0,80,81,5,97,0,0,81,82,5,121,0,0,82,83,5,95,0,0,83,84,5,111,0,
        0,84,85,5,102,0,0,85,86,5,95,0,0,86,87,5,98,0,0,87,88,5,105,0,0,
        88,89,5,114,0,0,89,90,5,116,0,0,90,104,5,104,0,0,91,92,5,65,0,0,
        92,93,5,71,0,0,93,94,5,69,0,0,94,95,5,95,0,0,95,96,5,65,0,0,96,97,
        5,84,0,0,97,98,5,95,0,0,98,99,5,73,0,0,99,100,5,78,0,0,100,101,5,
        68,0,0,101,102,5,69,0,0,102,104,5,88,0,0,103,52,1,0,0,0,103,65,1,
        0,0,0,103,79,1,0,0,0,103,91,1,0,0,0,104,6,1,0,0,0,105,106,5,118,
        0,0,106,107,5,97,0,0,107,108,5,108,0,0,108,109,5,117,0,0,109,110,
        5,101,0,0,110,111,5,95,0,0,111,112,5,97,0,0,112,113,5,115,0,0,113,
        114,5,95,0,0,114,115,5,110,0,0,115,116,5,117,0,0,116,117,5,109,0,
        0,117,118,5,98,0,0,118,119,5,101,0,0,119,120,5,114,0,0,120,8,1,0,
        0,0,121,122,5,113,0,0,122,123,5,117,0,0,123,124,5,97,0,0,124,125,
        5,110,0,0,125,126,5,116,0,0,126,127,5,105,0,0,127,128,5,116,0,0,
        128,129,5,121,0,0,129,10,1,0,0,0,4,0,29,50,103,0
    ];

    private static __ATN: antlr.ATN;
    public static get _ATN(): antlr.ATN {
        if (!NumericAttributesLexer.__ATN) {
            NumericAttributesLexer.__ATN = new antlr.ATNDeserializer().deserialize(NumericAttributesLexer._serializedATN);
        }

        return NumericAttributesLexer.__ATN;
    }


    private static readonly vocabulary = new antlr.Vocabulary(NumericAttributesLexer.literalNames, NumericAttributesLexer.symbolicNames, []);

    public override get vocabulary(): antlr.Vocabulary {
        return NumericAttributesLexer.vocabulary;
    }

    private static readonly decisionsToDFA = NumericAttributesLexer._ATN.decisionToState.map( (ds: antlr.DecisionState, index: number) => new antlr.DFA(ds, index) );
}